import { IAppState, TActions } from '../../common/state';
import { jq } from '../../json_query';

export function decorationsListReducer(state: IAppState, action: TActions): IAppState {
  const jsonQuery = jq(state.filters.jsonQuery);

  switch (action.type) {
    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'decorations_list') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jsonQuery.unsetDecorationsListItem(action.tag.value),
          },
        };
      }

      return state;

    default:
      return state;
  }
}
